import React from "react";
import { LOGO_URL, ICON_URL } from "@/lib/api";

/**
 * Wordmark — the full brand logo (with "Aangan Theory" lettering).
 * Used in Navbar, Footer, Admin sidebar.
 */
export function BrandWordmark({ className = "", height = 22 }) {
    return (
        <img
            src={LOGO_URL}
            alt="Aangan Theory"
            style={{ height, width: "auto" }}
            className={className}
        />
    );
}

/**
 * Icon-only mark — the "A" geometric mark with saffron parallelogram.
 * Used as favicon, decorative backdrop, small badge spots.
 */
export function BrandMark({ size = 28, className = "" }) {
    return (
        <img
            src={ICON_URL}
            alt="Aangan Theory"
            style={{ width: size, height: size }}
            className={className}
        />
    );
}

/**
 * Decorative background: large brand "A" + glow + grid hairlines.
 * Use behind hero sections.
 */
export function GeoBackdrop({ className = "" }) {
    return (
        <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
            {/* large brand A — semi visible */}
            <img
                src={ICON_URL}
                alt=""
                className="absolute -right-32 -top-24 w-[820px] max-w-none opacity-[0.07] select-none float-slow"
            />
            {/* saffron radial glow */}
            <div className="absolute inset-0 bg-saffron-glow" />
            {/* fine grid */}
            <div className="absolute inset-0 bg-grid opacity-50" />
            {/* hairline verticals */}
            <svg
                className="absolute inset-0 w-full h-full"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                viewBox="0 0 1440 800"
            >
                <defs>
                    <linearGradient id="vline-bd" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="rgba(255,255,255,0)" />
                        <stop offset="50%" stopColor="rgba(255,255,255,0.07)" />
                        <stop offset="100%" stopColor="rgba(255,255,255,0)" />
                    </linearGradient>
                </defs>
                {Array.from({ length: 7 }).map((_, i) => (
                    <line
                        key={i}
                        x1={(1440 / 8) * (i + 1)}
                        x2={(1440 / 8) * (i + 1)}
                        y1="0"
                        y2="800"
                        stroke="url(#vline-bd)"
                        strokeWidth="1"
                    />
                ))}
            </svg>
        </div>
    );
}

/** Section-level ambient glow (smaller, for non-hero sections). */
export function AmbientGlow({ className = "", side = "right" }) {
    const pos = side === "right" ? "right-[-20%]" : "left-[-20%]";
    return (
        <div className={`pointer-events-none absolute top-0 ${pos} w-[600px] h-[600px] ${className}`} aria-hidden>
            <div
                className="w-full h-full opacity-30"
                style={{
                    background:
                        "radial-gradient(circle, rgba(242,163,30,0.18) 0%, rgba(242,163,30,0) 60%)",
                }}
            />
        </div>
    );
}
